// Labels for the Active assignments "Type" column. Assignments saved before
// Starter Pack existed come back without the flag; they always sent to new users.
export const assignmentTypes = (assignment) => {
    const types = [];
    if (assignment.starterPack ?? true) types.push("Starter Pack");
    if (assignment.refreshEnabled ?? assignment.annualRefresh ?? false) types.push("Annual Refresh");
    return types;
};
